import { IContent } from 'models/content.model';

export const content: IContent = {
  nl: {
    defaultOption: 'Maak een keuze',
  },
  en: {},
};
